/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotInKeyPublicBase58: core.serialization.ObjectSchema<
    serializers.NotInKeyPublicBase58.Raw,
    Truvity.NotInKeyPublicBase58
> = core.serialization.object({
    values: core.serialization.list(core.serialization.string()),
});

export declare namespace NotInKeyPublicBase58 {
    export interface Raw {
        values: string[];
    }
}
